let activeSignIns = 0;

/**
 * Marks this tab as signing in until the returned function is called (CUR-2637).
 *
 * The login callback holds it from `AuthStore.login()` until it has navigated away from
 * /callback, so a remote `token-expired` that lands after `login()` settles, while
 * `recordSuccessfulLogin` is still in flight, does not clear the token this tab has just minted.
 * Counted rather than a boolean so one holder's release cannot end another's; each release is
 * idempotent.
 */
export function beginSignIn(): () => void {
    activeSignIns += 1;
    let released = false;
    return () => {
        if (released) return;
        released = true;
        activeSignIns -= 1;
    };
}

export function isSigningIn(): boolean {
    return activeSignIns > 0;
}
